// extracted by mini-css-extract-plugin
module.exports = {"reminderToJoinButton":"SendReminderToJoinButton_reminderToJoinButton__10qCr"};